import { BORDER_COLORS } from '@constants/colors.ts';
import { Tooltip as AntTooltip } from 'antd';
import styled from 'styled-components';

export const Tooltip = styled(AntTooltip)``;

export const modalForceStyles = {
    TooltipContainer: {
        background: BORDER_COLORS.white,
        border: `1px solid ${BORDER_COLORS.default}`,
        borderRadius: '8px',
        boxShadow: '0px 8px 16px -2px rgba(27, 33, 44, 0.12)',
    },
};

export const SvgTrigger = styled.span`
    svg {
        width: 16px;
        height: 16px;
        cursor: pointer;
        margin-top: 3px;
    }
`;
